import settingsService from '../api';
import { SET_SETTINGS, SET_MAX_KEYS, SET_PRODUCT, SET_PLUGIN_INFO } from './settings.constants';


export const getSettingsTC = () => {
  return async (dispatch) => {
    try {
      const resp = await settingsService.getSettings();

      if (!resp?.data) {
        return;
      }

      dispatch(setSettingsAC(resp.data));
    } catch (error) {
      console.log(error);
    }
  };
};

export const getMaxKeysTC = () => {
  return async (dispatch) => {
    try {
      const maxKeys = +localStorage.getItem("maxCopyKeys")

      if (!maxKeys) {
        return;
      }

      dispatch(setMaxKeysAC(maxKeys));
    } catch (error) {
      console.log(error);
    }
  };
};

export const getProductTC = (userId) => {
  return async (dispatch) => {
    try {
      //const resp = await settingsService.patreon()
      const resp = await settingsService.getProduct(userId);
      console.log(resp)

      if (!resp?.data) {
        return;
      }

      //var wnd = window.open("about:blank", "", "_blank");
      //wnd.document.write(resp?.data);

      dispatch(setProductAC(resp.data));
    } catch (error) {
      console.log(error);
    }
  };
}

export const getPluginTC = () => {
  return async (dispatch) => {
    try {
      const data = await settingsService.getPlugin();
      console.log(data)

      if(data?.status === 200) {
        const blob = new Blob([data.data], { //[new Uint8Array(data.data)]
          type: 'application/zip',
        });

        return blob;
      }

      throw new Error("The server did not return a result");
    } catch (error) {
      console.log(error);
      alert('Error download plugin.', error)
    }
  }
}

export const getPluginInfoTC = () => {
  return async (dispatch) => {
    try {
      const resp = await settingsService.getPluginInfo();
      
      dispatch(setPluginInfoAC(resp?.data));
    } catch (error) {
      console.log(error);
    }
  }
}

//ACTIONS
export const setSettingsAC = (payload) => {
  return {
    type: SET_SETTINGS,
    payload,
  };
};

export const setMaxKeysAC = (payload) => {
  return {
    type: SET_MAX_KEYS,
    payload,
  };
};

export const setProductAC = (payload) => {
  return {
    type: SET_PRODUCT,
    payload,
  };
};

export const setPluginInfoAC = (payload) => {
  return {
    type: SET_PLUGIN_INFO,
    payload,
  };
};
